"use client";

import { useEffect, useState } from "react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
export default function ServicesHero() {
  const {
    ref: heroRef,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  const [scrollY, setScrollY] = useState(0);
  useEffect(() => {
    const handleScroll = () => {
      setScrollY(window.scrollY);
    };
    const prefersReducedMotion = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
    if (!prefersReducedMotion) {
      window.addEventListener("scroll", handleScroll);
      return () => window.removeEventListener("scroll", handleScroll);
    }
  }, []);
  const parallaxScale = 1 + scrollY * 0.0005;
  return <section id="services-hero" ref={heroRef} className="relative min-h-[600px] overflow-hidden bg-background">
      {}
      <div className="absolute inset-0 bg-cover bg-center transition-transform duration-[var(--duration-medium)] ease-[var(--ease-smooth)]" style={{
      transform: `scale(${parallaxScale})`
    }}>
        <div className="surface-overlay" />
      </div>

      {}
      <div className="relative mx-auto max-w-7xl px-6 py-24 lg:px-8">
        <div className="grid grid-cols-1 gap-12 lg:grid-cols-2 lg:gap-16">
          {}
          <div className={`flex flex-col justify-center space-y-6 transition-all duration-[var(--duration-medium)] ease-[var(--ease-spring)] ${isVisible ? "animate-fade-in-up" : "opacity-0 translate-y-5"}`}>
            <h1 className="font-display text-[48px] font-bold leading-[1.2] tracking-tight text-secondary lg:text-[56px]">
              Evidence-Based Physiotherapy in Sydney
            </h1>
            <p className="text-lg leading-relaxed text-secondary lg:text-xl">
              Personalized care for active adults, sports injuries, and post-surgery rehabilitation. Our qualified physiotherapist provides trustworthy, clinical treatment tailored to your needs.
            </p>
          </div>
        </div>
      </div>
    </section>;
}